import { createFileRoute } from '@tanstack/react-router'
import { Funcionarios } from '@/features/funcionarios'
import { requireAdminOrAvaliador } from '@/lib/route-guards'

export const Route = createFileRoute('/_authenticated/funcionarios/')({
  beforeLoad: async () => {
    await requireAdminOrAvaliador()
  },
  component: Funcionarios,
})
